const component = "site-section-category-drawer";

export const siteSectionCategoryDrawer = {
  component,
  closeButton: `${component}/close-button`,
  searchInput: `${component}/search-input`,
  createButton: `${component}/create-button`,
  categoryRow: (categoryId: number | string): string => `${component}/category/${categoryId}`,
  categoryName: (categoryId: number | string): string => `${component}/category/${categoryId}/name`,
  assignButton: (categoryId: number | string): string => `${component}/category/${categoryId}/assign-button`,
  editButton: (categoryId: number | string): string => `${component}/category/${categoryId}/edit-button`,
  editInput: (categoryId: number | string): string => `${component}/category/${categoryId}/edit-input`,
  editConfirmButton: (categoryId: number | string): string => `${component}/category/${categoryId}/edit-confirm-button`,
  editCancelButton: (categoryId: number | string): string => `${component}/category/${categoryId}/edit-cancel-button`,
  deleteButton: (categoryId: number | string): string => `${component}/category/${categoryId}/delete-button`,
};
